import { Yii } from "libraries/interfaces/Yii";
import _keys from 'lodash-es/keys';
import _isUndefined from 'lodash-es/isUndefined';
import _cloneDeep from 'lodash-es/cloneDeep';
import _isString from 'lodash-es/isString';
import _isEqual from 'lodash-es/isEqual';
import _assign from 'lodash-es/assign';
import _set from 'lodash-es/set';
import _get from 'lodash-es/get';
import _split from 'lodash-es/split';
import _forEach from 'lodash-es/forEach';
import _join from 'lodash-es/join';
import _reverse from 'lodash-es/reverse';
import * as moment from 'moment';
// Angular
import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
// Services
import { FormService } from "libraries/service/form/form.service";
// Actions
import { Actions } from './utils/actions/index';

import * as g from './utils/groups/index';

/**
 * GenericForm: Shared variables and functions form
 */
@Directive()
export abstract class GenericForm {

    /**
     * options for multiselectable fields in the form
     * @method Input
     */
    @Input()
    public options: any;

    /**
     * options for multiselectable fields in the form
     * @method Input
     */
    @Output()
    public readonly sendrequest: EventEmitter<any> = new EventEmitter();

    public additionalOptions: any = {};

    public submitted: boolean = false;

    public defaultValue: any = {};

    /** Config is setting by default */
    public abstract config: any;

    /** form is a must have. He define the context of the entiere form */
    public form: FormGroup;

    /** Get all actions */
    public actions = Actions;

    /** Utils get keys object in template */
    public objectKeys = Object.keys;

    // defines the UI flags for the forms
    // fill this object
    public flags: any = {
        showFullForm: false // does handle the collapsed fields of the form
    };

    public Yii = Yii;

    public runSubmit2 = false;


    /**
     * generic translations
     */
    public t_search: string = Yii.t('wui-shared-js', 'Rechercher');
    public t_reset: string = Yii.t('wui-shared-js', 'Reset');
    public t_advanceSearch: string = Yii.t('wui-shared-js', 'Recherche avancée');


    /**
     * get Default vals for Hotel from json File
     */
    public defaultUrl = sessionStorage.getItem('$wui_url') + "config/forms/form_global.json";
    public defaultAppUrl: any;

    /** DI - fb: Formbuilder */
    constructor(public fb: FormBuilder,
        public formService?: FormService
    ) { }


    /**
     * constructForm Contruct form from config
     * Using for disable or enable part of existing form
     */
    public constructForm(): any {
        const constructForm: any = {};

        _keys(this.config).map((key: string) => {
            const keyItem = this.config[key];

            if (keyItem.hasGroup) {
                const groupName: string = _isString(keyItem.groupName) ? keyItem.groupName : key;
                constructForm[key] = g[groupName + 'Group'](this.fb, { count: keyItem.count, context: keyItem.context });
            } else if (keyItem.hasControl) {
                let typeFormat: any;
                // sets the default value if defined in config
                if (keyItem.defaultValue) {
                    typeFormat = keyItem.defaultValue;
                } else {
                    // sets the type format if defined in config
                    typeFormat = _isUndefined(keyItem.type) ? '' : keyItem.type;
                }
                constructForm[key] = this.fb.control(typeFormat);
            }
        });
        return constructForm;
    }

    /**
     * onSubmit call service to send request to API
     * @param value : values of fields, valid: a boolean after checking Validators
     */
    public onSubmit({ value, valid }: { value: any, valid: boolean }): void {
        if (!this.runSubmit2) {
            if (valid) {
                this.formService.setData(value);
                this.sendrequest.emit(value);
            }
        } else {
            this.onSubmit2(this.form);
        }

    }
    public onSubmit2({ value, errors }: { value: any, errors: any }): void {
        if (!errors) {
            this.formService.setData(value);
            this.sendrequest.emit(value);
        }
    }




    /**
     * check form change, used in order to block the sendrequest
     * @method checkFormChange
     * @param {Object} newValue
     */
    public checkFormChange(newValue: any): boolean {
        // clear spécific values in origin data and un-settable values in the form :
        const rootOrigin = _cloneDeep(this.formService.removeEmptyObjectsAndFormatDate(this.defaultValue));
        // clear specific values in new value and un-settable values in the form:
        const rootNew = _cloneDeep(this.formService.removeEmptyObjectsAndFormatDate(newValue));

        // check root change
        const equalityOnRoot = _isEqual(rootOrigin, rootNew);

        const hasChanged: boolean = !equalityOnRoot ? true : false;

        return hasChanged;
    }



    /**
     * handles the toggle of showFullForm flag
     * @method toggleHiddenFields
     * @param {Boolean} _forceValue => force the value of the toggling flag
     */
    public toggleHiddenFields(_forceValue?: boolean) {
        this.flags.showFullForm = !this.flags.showFullForm;
    }

    /**
     * Reset the entiere form;
     */
    public reset(): void {
        this.form.reset();
    }

    /**
     * Reset the entiere form;
     */
    public reload(_defaultJson: any): void {
        if (!_defaultJson) {
            _defaultJson = {};
        }

        this.form.reset(_defaultJson);


    }

    /**
     * init()
     * empty init function to fill in component that inherit from GenericForm
     */
    public init(): void {
        //
    }

    public ngOnInit() {
        this.form = this.fb.group({
            ...this.constructForm()
        });

        // complete input options with options declared in the forms
        this.options = _assign({}, this.options, this.additionalOptions);

        this.init();
    }

    public getDefault(): void {
        this.formService.getDefault(this.defaultUrl, this.defaultAppUrl);
    }

    /**
     * can a template be shown
     * @param {string} name
     * @returns {boolean}
     */
    public canShow(name: string): boolean {
        return this.config && this.config[name] && this.config[name].hasTemplate;
    }

    public getContent(_ctrl: any): any {
        if (_ctrl) {
            return _ctrl.value;
        }
    }

    /**
     * parse the input dates for the form usage
     * @param {Object} changedValue => the fresh value to parse
     * @param {string[]} dateList => the datelist paths array
     * @method setDates
     */
    public parseDate(changedValue: any, dateList: string[]): void {
        if (this.form) {
            _forEach(dateList, (path: string) => {
                const oldDate = _get(changedValue, path);
                if (oldDate && _isString(oldDate)) {
                    _set(changedValue, path, this.dateMoment(oldDate));
                }
            });
            this.form.patchValue(changedValue);
        }
    }

    /**
     * Check with 'path' is touched && has Error
     * @param {string} _path : path to the field
     * @param {string} _errorName : error to catch
     * @returns {boolean}
     */
    public hasError(_path: string | any[], _errorName: string): boolean {
        if (this.submitted) {
            return this.form.get(_path).hasError(_errorName);
        } else {
            return this.form.get(_path).touched && this.form.get(_path).hasError(_errorName);

        }
    }


    /**
     * date Reverse ; '2008-02-23' et '23-02-2008'
     * @param {string} _date
     */
    protected dateReverse(_date: string) {
        if (_isString(_date)) {
            let dateArray = _split(_date, '-');
            if (dateArray.length === 3) {
                dateArray = _reverse(dateArray);
                _date = _join(dateArray, '/');
                return _date;
            }
            return _date;
        }
        return "";
    }

    /**
     * date Moment ; '2008-02-23' to moment Date
     * @param {string} _date
     */
    protected dateMoment(_date: any) {
        if (_isString(_date)) {
            const dateArray = _split(_date, '-');
            if (dateArray.length === 3) {
                _date = moment(_date, 'YYYY-MM-DD').toDate();
                return _date;
            }
            return _date;
        }
        return "";
    }

}
